import { Modal, Tabs, Spin } from "antd";
import { CALL_API } from "common/API";
import { STATUS_CODE } from "common/Constants";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getUserInfo, getUserList } from "redux/selectors";

const TABS = [
  { key: "COMPANY", label: "Company KPI" },
  { key: "DEPARTMENT", label: "Departmental KPI" },
];

const KpiViewModal = ({ open, onClose }) => {
  const userInfo = useSelector(getUserInfo);
  const userList = useSelector(getUserList);
  const [activeTab, setActiveTab] = useState("COMPANY");
  const [previewUrl, setPreviewUrl] = useState("");
  const [loading, setLoading] = useState(false);

  const myDepartmentId = userList.find((u) => u.userid === userInfo?.userid)?.basedepartmentid;

  const fetchPreview = async (docid) => {
    setPreviewUrl("");
    if (!docid) return;
    setLoading(true);
    try {
      const { url, code } = await CALL_API(
        `performance-kpi-management/companykpifile/${docid}`,
        "get"
      );
      if (code === STATUS_CODE.SUCCESS) setPreviewUrl(url);
    } catch (error) {
      console.error("Error fetching KPI preview:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!open) return;
    const docid = activeTab === "COMPANY" ? "COMPANY" : myDepartmentId;
    fetchPreview(docid);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, activeTab]);

  return (
    <Modal
      title="Company & Departmental KPIs"
      open={open}
      onCancel={onClose}
      footer={null}
      width={900}
      centered
    >
      <Tabs activeKey={activeTab} onChange={setActiveTab} items={TABS} />
      <div style={{ height: 500 }}>
        <Spin spinning={loading}>
          {previewUrl ? (
            <iframe
              title="KPI Document"
              src={previewUrl}
              width="100%"
              height="500"
              style={{ border: "none" }}
            />
          ) : (
            <div className="text-center lite-text mt-5">
              {loading ? "" : "No Document available"}
            </div>
          )}
        </Spin>
      </div>
    </Modal>
  );
};

export default KpiViewModal;
